<template>
	<dialog-generic :visibility.sync = 'visibility' :indicator = 'indicator'>
        <template v-slot:title>{{report.name || report.report_name}}</template>
        <template v-slot:content>
            <div class = 'py-3' v-if = 'purgeReport'>Удалить отчет?</div>
	        <div class = 'py-3' v-else>Отключиться от отчета?</div>
        </template>
        <template v-slot:action>
			<v-btn class = 'px-0 red--text text--darken-2' :loading = 'indicator' block depressed @click = 'makeAction'>
				{{ purgeReport? "Удалить":"Отключиться" }}
			</v-btn>
		</template>
    </dialog-generic>
</template>

<script>
	import DialogGeneric from '@/components/elements/dialogs/Generic.vue'

	export default {
		name: 'ReportDeleteDialog',
		props: ['initialState', 'data', 'postAction', 'purgeReport'],
		components: {'dialog-generic': DialogGeneric},
		data() {
			return {
				visibility: this.initialState,
				report: this.data,
				indicator: false,
			}
		},
		 watch: {
	        initialState(value) {
	            this.visibility = value
	        },
	        visibility(value) {
	            this.$emit('update:initialState', value);
	        },
	        data(value) {
	            this.report = value
	        }
	    },
		methods: {
			makeAction() {
				if (this.purgeReport) {
					this.deleteReport()
				} else {
					this.deactivateReport()
				}
			},
			deleteReport() {
				this.indicator = true;
				let requestHeaders = {
		          'Content-Type': 'application/json;charset=UTF-8',
		          'Authorization': 'Bearer ' + String(this.$store.getters.userToken)
		        };
		        let requestData = {
		          'login': this.$store.getters.userLogin,
		          'report_id': this.report.report_id
		        }
		        this.$http.patch(this.$store.getters.endpoint + '/db/project/' + this.projectId + '/reports',
		          requestData,
		          {headers: {...this.$store.state.restrictedHeaders,...requestHeaders}}
		        ).then( (r) => {
		        	this.postAction('reports');
		        	this.visibility = false;
		        	this.indicator = false;
		        });
			},
			deactivateReport() {
		        this.indicator = true;
		        let requestHeaders = {
		          'Content-Type': 'application/json;charset=UTF-8',
		          'Authorization': 'Bearer ' + String(this.$store.getters.userToken)
		        }
		        let requestData = {
		          'login': this.$store.getters.userLogin,
		          'uid': [this.$store.getters.userId],
		          'report_id': this.report.report_id
		        }
		        this.$http.patch(this.$store.getters.endpoint + '/db/reports/persons', 
		          requestData,
		          {
		            headers: {...this.$store.state.restrictedHeaders,...requestHeaders}
		          }).then( (r) => {
		            let response = r.body;
		            if (response.result) {
					  this.indicator = false;
					  this.$dataLayer.$emit('enrich', {
                        event: 'crud',
                        data: {
                            type: 'delete',
                            target: 'report'
                        },
                        once: false
                    })
					  this.postAction && this.postAction();
					  this.$emit('requestUpdateReportsList', 'requestUpdateReportsList')
		              this.visibility = false;
		            } else {
		              console.log(response)
		            }
		        })
		    }
		}
	}
</script>